<template>
  <div style="height: 100%;">
    <el-header class="content">
      <h3 class="title">
        <div class="block">
          <span>快捷设置</span>
        </div>
      </h3>
    </el-header>
    <div style="width: 100%;margin-top: 20px">
      <div>
        <ul class="list-setting" v-for="(item, index) in shortcutKeys" :key="index">
          <li class="item-setting">
            <h4>{{ item.label }}</h4>
            <div>
              <span>切换快捷键</span>
              <span class="btn-key btn-key-default">{{ item.value }}</span>
              <ul class="list-key">
                <li>
                  <span class="btn-key" :class="item.value === 'F1' ? 'active' : ''" @click="changeShortcutKey('F1', index)">F1</span>
                </li>
                <li>
                  <span class="btn-key" :class="item.value === 'F2' ? 'active' : ''" @click="changeShortcutKey('F2', index)">F2</span>
                </li>
                <li>
                  <span class="btn-key" :class="item.value === 'F3' ? 'active' : ''" @click="changeShortcutKey('F3', index)">F3</span>
                </li>
                <li>
                  <span class="btn-key" :class="item.value === 'F4' ? 'active' : ''" @click="changeShortcutKey('F4', index)">F4</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <el-button size="medium" type="primary" @click="saveShortcutKey()">保存更新快捷设置</el-button>
      </div>
    </div>
</div>
</template>
<script>
import { getShortcutKeyById, updateShortcutKeyById } from '@/api/user'
export default {
  data() {
    return {
      shortcutKeys: []
    }
  },
  created() {
    this.getShortcutKey()
  },
  methods: {
    changeShortcutKey(value, index) {
      this.shortcutKeys[index].value = value
    },
    saveShortcutKey() {
      var newShortcutKeys = Array.from(new Set(this.shortcutKeys.map(item => item.value)))
      if (newShortcutKeys.length < this.shortcutKeys.length) {
        this.$message.error('当前快捷键设置存在冲突，请重新设置!')
        return
      }
      var newMap = {}
      this.shortcutKeys.forEach(sk => {
        const key = sk.label
        const value = sk.value
        newMap[key] = value
      })
      const userId = this.$store.state.user.userInfo.id
      const shortcutKey = JSON.stringify(newMap)
      updateShortcutKeyById(userId, shortcutKey).then(res => {
        if (res.code === 2000) {
          this.$message.success('快捷键设置成功!')
          this.$store.commit('user/setShortcutKey', this.shortcutKeys)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getShortcutKey() {
      const userId = this.$store.state.user.userInfo.id
      getShortcutKeyById(userId).then(res => {
        if (res.code === 2000) {
          this.shortcutKeys = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  margin: 0;
  padding: 0;
}

.list-setting {
  margin-bottom: 20px;
  li {
    display: inline-block;
  }
  .item-setting {
    display: block;
    border-bottom: 1px solid #ebebeb;
    color: #666;
    font-size: 14px;
    padding: 10px 0;
    h4 {
      font-weight: bold;
      color: #333;
      font-size: 14px;
      margin-bottom: 8px;
    }
    .list-key {
      display: inline-block;
      margin-left: 40px;
    }
    .btn-key {
      display: inline-block;
      cursor: pointer;
      margin-left: 10px;
      color: #f8f9fb;
      font-weight: bold;
      background-color: #d7dce0;
      border: 1px solid #d7dce0;
      border-radius: 4px;
      padding: 2px 4px;
      &.btn-key-default {
        cursor: default;
        color: #f26f6e;
        background-color: #f4f4f5;
        border: 1px solid #ddd;
      }
      &.active {
        color: #f8f9fb;
        background-color: #7bc3fb;
        border: 1px solid #7bc3fb;
      }
    }
  }
}
</style>
